import ReactUploadSelf from './components';
export default ReactUploadSelf;
